import { createFileRoute } from '@tanstack/react-router';

import { ValidationIssuesTab } from '../../components';

const ParticipantsTab = () => (
  <ValidationIssuesTab
    issueCodes={[
      'enrollmentMissingParticipant',
      'iveMissingEnrollment',
      'iveMissingVehicle'
    ]}
  />
);

export const Route = createFileRoute('/relationship-health/participants')({
  component: ParticipantsTab
});
